import React from "react";
import { User } from "@common/types/user";
import { WORKSPACE_ROLES_LABELS } from "@common/constants";
import { UserWorkspaceRole } from "@common/userWorkspaceRoles";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";

interface Props {
    user: User;
    role: UserWorkspaceRole;
}

/** A person on the entity team, with their email and role in a tooltip. */
export const EntityTeamMember: React.FC<Props> = ({ user, role }) => (
    <AvatarTooltip
        title={user.name}
        content={
            <>
                {user.email}
                <br />
                {WORKSPACE_ROLES_LABELS[role]}
            </>
        }
    >
        <UserAvatar user={user} />
    </AvatarTooltip>
);
